import React from 'react';
import Alert from "react-bootstrap/Alert";

const AlertMessage = ({ type, message, style, className, hideIcon, children }) => {
    let variant = "secondary";

    let icon = <i className="fa-solid fa-triangle-exclamation"></i>;
    switch (type) {
        case 'info':
            variant = "info";
            icon = <i className="fa-solid fa-circle-info"></i>;
            break;
        case 'success':
            variant = "success";
            icon = <i className="fa-regular fa-circle-check"></i>;
            break;
        case 'error':
            variant = "danger";
            break;
        case 'warning':
            variant = "warning";
            icon = <i className="fa-solid fa-triangle-exclamation"></i>;
            break;
    }

    return (
        <Alert variant={variant} className={className} style={{ width: "100%", ...style }}>
            {!hideIcon && icon} {message}
            { children }
        </Alert>
    );
}

export default AlertMessage;